export default "__VITE_ASSET__CzjvD6st__"